import { AxiosInstance, AxiosRequestConfig } from 'axios';

import { ImportPayload } from './types';
const ENDPOINT = 'file/';

interface FileUploadPayload {
  images: ImportPayload[];
  equip_model_id?: number;
  stand_model_id?: number;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (
  instance: AxiosInstance,
  config: AxiosRequestConfig,
  restConfig: AxiosRequestConfig
) => ({
  get: (id: string) => instance.get<string>(ENDPOINT + `get/${id}/`, config),
  upload: (payload: FileUploadPayload) =>
    instance.post(ENDPOINT + 'image/upload/', payload, restConfig),
  remove: (id: string) =>
    instance.delete(ENDPOINT + `delete/${id}/`, restConfig),
});
